import { Model } from 'dva';
import { AnyAction } from 'redux';
import deepmerge from 'deepmerge';

import { Field } from '../declarations/widget-ums';
import { EMPTY_FIELD } from '../constants/emptyField';
import { hasErrors } from '../validators';
import { AGREEMENTS } from '../constants/modelNames';

export interface AgreementsProps {
  warnedAboutResponsibility: Field<boolean>;
  consentWithTerms: Field<boolean>;
  needPaperCertificate: Field<boolean>;
  centerPGU: Field<boolean>;
}

export const EMPTY_CHECKBOX_FIELD = {
  ...EMPTY_FIELD,
  checked: false,
};

export const initialAgreementsState = {
  warnedAboutResponsibility: EMPTY_CHECKBOX_FIELD,
  consentWithTerms: EMPTY_CHECKBOX_FIELD,
  needPaperCertificate: EMPTY_CHECKBOX_FIELD,
  centerPGU: EMPTY_FIELD,
};

const agreementsModel: Model = {
  namespace: AGREEMENTS,
  state: initialAgreementsState,
  reducers: {
    onChange<Reducer>(state: AgreementsProps, { payload }: AnyAction) {
      return { ...state, ...payload };
    },
    'set/error'(state, { payload }) {
      return deepmerge(state, payload);
    },
    'set/draftData'(state, { payload }) {
      return deepmerge(state, payload);
    },
    reset() {
      return initialAgreementsState;
    },
  },
  effects: {
    *onChange(_, { put }) {
      yield put({
        type: `form/saveDraft`,
      });
    },
    formErrorWatcher: [
      function* ({ take, put }) {
        while (true) {
          const {
            payload: { agreements },
          } = yield take('form/set/error');
          const agreementsHasErrors = hasErrors(agreements);

          if (agreementsHasErrors) {
            yield put({ type: 'set/error', payload: agreements });
          }
        }
      },
      { type: 'watcher' },
    ],
    draftWatcher: [
      function* ({ take, put }) {
        while (true) {
          const {
            payload: { agreements },
          } = yield take('form/set/draftData');
          yield put({
            type: 'set/draftData',
            payload: deepmerge(initialAgreementsState, agreements),
          });
        }
      },
      { type: 'watcher' },
    ],
    formResetWatcher: [
      function* ({ take, put }) {
        while (true) {
          yield take('form/reset');
          yield put({ type: 'reset' });
        }
      },
      { type: 'watcher' },
    ],
  },
};

export default agreementsModel;
